import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import Solutions from "@/pages/Solutions";
import BusinessXRay from "@/pages/BusinessXRay";
import WhoWeHelp from "@/pages/WhoWeHelp";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-ivory px-6 text-center">
                    <div>
                        <p className="font-display text-2xl font-extrabold text-ink">Something went wrong.</p>
                        <p className="mt-3 text-slategray">Please refresh the page. The Vantera team has been notified.</p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const App = () => {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = undefined;
        };
    }, []);

    return (
        <BrowserRouter>
            <MotionConfig reducedMotion="user">
                <ErrorBoundary>
                    <ScrollManager />
                    <Navbar />
                    <main id="main">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/how-it-works" element={<HowItWorks />} />
                            <Route path="/solutions" element={<Solutions />} />
                            <Route path="/business-x-ray" element={<BusinessXRay />} />
                            <Route path="/who-we-help" element={<WhoWeHelp />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/insights" element={<Insights />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/privacy" element={<Legal page="privacy" />} />
                            <Route path="/terms" element={<Legal page="terms" />} />
                        </Routes>
                    </main>
                    <Footer />
                </ErrorBoundary>
            </MotionConfig>
        </BrowserRouter>
    );
};

export default App;